import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Badge } from './ui/badge';
import { ExternalLink, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { formatRelativeTime, getAvatarFallback } from '../lib/utils';

export function UpdateCard({ update, onDelete, showUser = true }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 hover:border-slate-300 transition-colors">
      {showUser && (
        <div className="flex items-center gap-3 mb-3">
          <Link to={`/profile/${update.user_id}`}>
            <Avatar className="w-10 h-10">
              <AvatarImage src={update.user_picture} alt={update.user_name} />
              <AvatarFallback className="bg-orange-100 text-orange-700 text-sm">
                {getAvatarFallback(update.user_name)}
              </AvatarFallback>
            </Avatar>
          </Link>
          <div className="flex-1 min-w-0">
            <Link
              to={`/profile/${update.user_id}`}
              className="font-medium text-slate-900 hover:text-orange-600 text-sm"
            >
              {update.user_name}
            </Link>
            <p className="text-xs text-slate-500">{formatRelativeTime(update.created_at)}</p>
          </div>
          {onDelete && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDelete(update.update_id)}
              className="text-slate-400 hover:text-red-500"
            >
              <Trash2 className="w-4 h-4" />
            </Button>
          )}
        </div>
      )}

      <p className="text-slate-700 whitespace-pre-wrap leading-relaxed">{update.content}</p>

      {update.project_id && update.project_title && (
        <Link
          to={`/project/${update.project_id}`}
          className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 bg-orange-50 text-orange-700 rounded-lg text-sm font-medium hover:bg-orange-100 transition-colors"
        >
          <ExternalLink className="w-3.5 h-3.5" />
          {update.project_title}
        </Link>
      )}

      {!showUser && (
        <p className="text-xs text-slate-400 mt-3">{formatRelativeTime(update.created_at)}</p>
      )}
    </div>
  );
}
